import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const ApplicantFunnelChart = ({ data: liveData }) => {
  const mockFunnelData = [
    { stage: 'Applications', count: 1200, color: '#3B82F6' },
    { stage: 'Screening', count: 850, color: '#06B6D4' },
    { stage: 'Interview', count: 320, color: '#8B5CF6' },
    { stage: 'Final Round', count: 145, color: '#F59E0B' },
    { stage: 'Offers', count: 82, color: '#10B981' },
    { stage: 'Hired', count: 68, color: '#059669' }
  ];

  const funnelData = (liveData && liveData.length > 0) ? liveData : mockFunnelData;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground">{label}</p>
          <p className="text-sm text-muted-foreground">
            Count: <span className="font-semibold text-foreground">{payload[0].value}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Applicant Funnel</h3>
          <p className="text-sm text-muted-foreground">Current month recruitment pipeline</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">Conversion Rate</p>
          <p className="text-lg font-semibold text-success">9.0%</p>
        </div>
      </div>
      
      <div className="w-full h-80" aria-label="Applicant Funnel Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={funnelData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis 
              dataKey="stage" 
              tick={{ fontSize: 12, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
            />
            <YAxis 
              tick={{ fontSize: 12, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="count" radius={[4, 4, 0, 0]}>
              {funnelData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6">
        {funnelData.map((item, index) => (
          <div key={index} className="text-center">
            <div 
              className="w-4 h-4 rounded mx-auto mb-2"
              style={{ backgroundColor: item.color }}
            />
            <p className="text-xs text-muted-foreground">{item.stage}</p>
            <p className="text-sm font-semibold text-foreground">{item.count}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplicantFunnelChart;